import {DEGREE_TYPES, PROGRAM_DROPDOWN } from "@/components/molecules/ProgramMenu/form-constants";

const SELECT_DEGREE = "Select Degree";
const SELECT_PROGRAM = "Select Program";

const errorAccordingToFieldName = {
  fullName: "Please enter valid full name",
  countryCode: "Please enter valid country code",
  phoneNumber: "Please enter valid phone number",
  emailId: "Please enter valid email address",
  degree: "Please select a degree",
  program: "Please select a program",
  isTermsAccepted: "Please accept terms & conditions",
};

const degreeOptions = ["UG", "PG"];

const exlcudePrograms = [
	"BSc. (Hons.) in Information Technology",
	"MSc. in Information Technology",
	"MSc. Environmental Science",
];

const excludeProgramsOutsideIndia = [
    "BACHELOR OF ARTS (GENERAL) HINDI MEDIUM",
    "BACHELOR OF ARTS (GENERAL) IN KANNADA",
    "BACHELOR OF ARTS (GENERAL) IN MALAYALAM",
    "BACHELOR OF ARTS (GENERAL) IN TAMIL",
    "BACHELOR OF ARTS (GENERAL) IN TELUGU",
    "BACHELOR OF ARTS (HINDI MEDIUM)",
    "BACHELOR OF COMMERCE (GENERAL) HINDI MEDIUM",
    "BACHELOR OF COMMERCE (GENERAL) IN KANNADA",
    "BACHELOR OF COMMERCE (GENERAL) IN MALAYALAM",
    "BACHELOR OF COMMERCE (GENERAL) IN TAMIL",
    "BACHELOR OF COMMERCE (GENERAL) IN TELUGU",
  ];

const programsOptions = PROGRAM_DROPDOWN.filter(
    (e) => !exlcudePrograms.includes(e.title)
  )
    .filter(
      (x: any) =>
        x.programType &&
        degreeOptions.indexOf(String(x.programType).toUpperCase()) > -1
    )
    .map((x: any) => x.title);

const regexForInputs: any = {
    fullName: /^[a-zA-Z][a-zA-Z ]{2,49}$/,
    countryCode: /^\+(?:[0-9]?){6,14}[0-9]$/,
    phoneNumber: /^[1-9][0-9]{9}$/,
    emailId: /^(?!.*\.\.)[a-zA-Z0-9](\.?[a-zA-Z0-9_-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
    degree: new RegExp("^(" + degreeOptions.join("|") + ")$"),
    program: new RegExp("^(" + programsOptions.join("|") + ")$"),
    isTermsAccepted: /^true$/,
}

const precedentSelectedPrograms = (associatedPrograms: Array<ProgramDetails>) =>
  associatedPrograms.map((selectedProgram) =>
    selectedProgram.attributes.BasicDetails?.Heading.toUpperCase()
  );

const getProgramId = ({
  isLandingPage,
  associatedPrograms,
  program,
}: {
  isLandingPage: boolean;
  associatedPrograms: Array<ProgramDetails>;
  program: String;
}) =>
  isLandingPage
    ? associatedPrograms.find(
        (selectedProgram) =>
          selectedProgram.attributes.BasicDetails?.Heading.toUpperCase() ==
          String(program).toUpperCase()
      )?.attributes.BasicDetails?.PROGRAM_ID || ''
    : PROGRAM_DROPDOWN.find((e) => String(e.title).toLowerCase() == String(program).toLowerCase())
        ?.id || "";

const filterSelectedPrograms = ({
  associatedPrograms,
  degree = SELECT_DEGREE,
}: {
  associatedPrograms: Array<ProgramDetails>;
  degree: string;
}) => {
  return associatedPrograms.filter(
    (programOption) =>
      (programOption.attributes.BasicDetails?.ProgramType === DEGREE_TYPES[degree]?.id ||
        degree == SELECT_DEGREE) &&
      !!programOption.attributes.BasicDetails?.Heading
  );
};

const leadSquareApiCall = async (payload, form, ipStackDetails, tracking) => {
    return fetch("/api/salesforce.com/lead-create-new", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ipstack: ipStackDetails,
        form: { ...form, ...payload },
        meta: {
          ...tracking,
          utm_medium: tracking?.utm_medium || "faq_hub",
        },
      }),
    });
  };

  const connectCounsellorApiCall = (status, form, ipStackDetails, tracking) => fetch("/api/connect-counsellor", {
    method: "POST",
    body: JSON.stringify({
      ipstack: ipStackDetails,
      form,
      meta: {
        ...tracking,
        utm_medium: tracking?.utm_medium || "request_a_callback",
      },
      status,
    }),
  });

export {
  precedentSelectedPrograms,
  getProgramId,
  SELECT_DEGREE,
  SELECT_PROGRAM,
  filterSelectedPrograms,
  errorAccordingToFieldName,
  regexForInputs,
  degreeOptions,
  programsOptions,
  excludeProgramsOutsideIndia,
  leadSquareApiCall,
  connectCounsellorApiCall
};

